import { RectangleButton } from "../../shared/RectangleButton";

export const MenuRectangleButton = ({
  rectangleButtonText,
  onCurtainStart,
  curtainTo,
}) => {
  return (
    <div
      {...{
        style: {
          position: "absolute",
          width: "100%",
        },
      }}
    >
      <RectangleButton
        {...{
          text: rectangleButtonText,
          width: "100%",
          screen: "menu",
          onCurtainStart,
          curtainTo,
        }}
      />
    </div>
  );
};

export default MenuRectangleButton;
